export const UNIFORM_COMPOSITIONS_CACHE_TAG = 'uniform-compositions';
export const UNIFORM_COMPOSITION_REVALIDATE_TIME = 3600;

export function uniformCompositionCacheTag(slug: string): string {
  return `uniform-composition-${slug.replace(/\//g, '-')}`;
}
